(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-MY', {
        style: 'currency',
        currency: currency || 'MYR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return `RM${(cents / 100).toFixed(2)}`;
    }
  };

  const tierForQty = (qty) => {
    if (qty >= 3) return { pct: 10, label: '10% off applied at checkout' };
    if (qty >= 2) return { pct: 5, label: '5% off applied at checkout' };
    return null;
  };

  const isFestiveLine = (item) => {
    const vendor = (item.vendor || '').toLowerCase();
    const type = (item.product_type || '').toLowerCase();
    const tags = (item.properties && item.properties._tags) || '';
    if (!vendor.includes('biotex')) return false;
    if (type === 'combo') return false;
    if (String(tags).toLowerCase().includes('combo')) return false;
    return true;
  };

  let cartBiotexQty = 0;
  let cartPromise = null;

  const fetchCartBiotexQty = () => {
    if (cartPromise) return cartPromise;
    cartPromise = fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        cartBiotexQty = (cart.items || []).reduce((sum, item) => {
          return sum + (isFestiveLine(item) ? item.quantity : 0);
        }, 0);
        return cartBiotexQty;
      })
      .catch(() => {
        cartBiotexQty = 0;
        return 0;
      })
      .finally(() => {
        cartPromise = null;
      });
    return cartPromise;
  };

  const updatePromo = (root, qtyInput, biotexInCart) => {
    if (!root || !qtyInput) return;
    const pageQty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    // Count other Biotex already in cart + this page qty (treat as replacing cart qty for this variant if present)
    const variantId = parseInt(root.dataset.variantId, 10) || 0;
    let otherQty = biotexInCart || 0;
    // page qty is what customer is selecting now; cart already includes existing line for this variant.
    // Approximate: total festive qty if they add pageQty of this product =
    // (cart biotex excluding this variant) + pageQty
    const cartVariantQty = parseInt(root.dataset.cartVariantQty, 10) || 0;
    otherQty = Math.max(0, otherQty - cartVariantQty);
    const totalQty = otherQty + pageQty;

    const price = parseInt(root.dataset.price, 10) || 0;
    const currency = root.dataset.currency || 'MYR';
    const active = root.querySelector('[data-festive-active]');
    const tier = tierForQty(totalQty);

    root.hidden = false;
    root.classList.toggle('is-active', Boolean(tier));
    root.classList.toggle('is-tier-5', tier && tier.pct === 5);
    root.classList.toggle('is-tier-10', tier && tier.pct === 10);

    if (!active) return;
    if (!tier) {
      active.textContent = 'Any 2 Biotex products unlock 5% · any 3+ unlock 10%';
      return;
    }
    const unit = Math.round(price * (1 - tier.pct / 100));
    active.innerHTML = `<strong>${tier.pct}% off</strong> on Biotex at checkout — about ${money(
      unit,
      currency
    )} each for this item`;
  };

  const bind = (root) => {
    const section = root.closest('product-info') || root.closest('.product__info-wrapper') || document;
    const qtyInput =
      section.querySelector('.quantity__input') ||
      document.querySelector(`#Quantity-Form-${root.id.replace('BiotexFestivePromo-', '')} .quantity__input`);
    if (!qtyInput) return;

    const refresh = () => {
      fetchCartBiotexQty().then((qty) => updatePromo(root, qtyInput, qty));
    };
    qtyInput.addEventListener('change', refresh);
    qtyInput.addEventListener('input', refresh);
    const qtyWrap = qtyInput.closest('quantity-input');
    if (qtyWrap) {
      qtyWrap.addEventListener('click', () => requestAnimationFrame(refresh));
    }
    refresh();
  };

  const init = () => {
    document.querySelectorAll('[data-biotex-festive]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);
})();
